<template>
	<div>
		<!-- <transition name="fade-slide" mode="out-in"> -->
		<router-view></router-view>
		<!-- </transition> -->
	</div>
</template>

<script>
export default {
	name: 'Home'
}
</script>

<style lang="scss"></style>
